import { Provider } from "react-redux";
import thunk from "redux-thunk";
import { compose, combineReducers, createStore, applyMiddleware } from "redux";
import Routes from "./routes/Routes";
import axios from "axios";

import authenticationReducer from "./store/reducers/authenticationReducer";
import packagesReducer from "./store/reducers/packagesReducer";
import loadingReducer from "./store/reducers/loadingReducer";
import centersReducer from "./store/reducers/centersReducer";
import adminsReducer from "./store/reducers/adminsReducer";
import userReducers from "./store/reducers/userReducers";
import memberhipsReducer from "./store/reducers/memberhipsReducer";
import accessGroupsReducer from "./store/reducers/accessGroupsReducer";
import balancesReducer from "./store/reducers/balancesReducer";

import dayjs from "dayjs";
import courseReducer from "./store/reducers/courseReducer";
import ordersReducer from "./store/reducers/ordersReducer";
import expensesReducer from "./store/reducers/expensesReducer";
import supplementsReducer from "./store/reducers/supplementsReducer";
import cafeteriaItemsReducer from "./store/reducers/cafeteriaItemsReducer";
import purchasesActivityReducer from "./store/reducers/purchasesActivityReducer";
import supplementsStorageReducer from "./store/reducers/supplementsStorageReducer";
import supplementItemsReducer from "./store/reducers/supplementItemsReducer";
import credentialsReducer from "./store/reducers/credentialsReducer";
import io from "socket.io-client";
import dollarPricesReducer from "./store/reducers/dollarPricesReducer";
import { useEffect } from "react";
import i18n from "./i18n";
import courseTypes from "./store/reducers/courseTypesReducer";
import requestsReducer from "./store/reducers/requestsReducer";
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { executeSocketActions } from "./db/BioStar/APIs";

const utc = require("dayjs/plugin/utc");
const relativeTime = require("dayjs/plugin/relativeTime");
const duration = require("dayjs/plugin/duration");
const LocalizedFormat = require("dayjs/plugin/localizedFormat");

dayjs.extend(duration);
dayjs.extend(utc);
dayjs.extend(relativeTime);
dayjs.extend(LocalizedFormat)

axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? "https://akapower.xyz:4000/aka/api" : 'http://localhost:4000/aka/api'

// axios.defaults.timeout = 3000;

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const middleware = [thunk];

const appReducer = combineReducers({
  authentication: authenticationReducer,
  packages: packagesReducer,
  loading: loadingReducer,
  centers: centersReducer,
  admins: adminsReducer,
  users: userReducers,
  memberships: memberhipsReducer,
  accessGroups: accessGroupsReducer,
  courses: courseReducer,
  orders: ordersReducer,
  expenses: expensesReducer,
  supplements: supplementsReducer,
  cafeteriaItems: cafeteriaItemsReducer,
  balances: balancesReducer,
  purchasesActivity: purchasesActivityReducer,
  supplementsStorage: supplementsStorageReducer,
  supplementItems: supplementItemsReducer,
  credentials: credentialsReducer,
  dollarPrices: dollarPricesReducer,
  courseTypes,
  requests: requestsReducer,
});

const rootReducer = (state, action) => {
  if (action.type === "LOGOUT") {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(...middleware))
);

export const socket = io.connect(process.env.NODE_ENV === 'production' ? "https://akapower.xyz:4000/aka/api" : 'http://localhost:4000/');

socket.on("onSocketAction", (data) => {
  console.log({data},'onSocketAction')
  executeSocketActions()
});


function App() {
  useEffect(() => {
    // console.log(localStorage.getItem('language'))
    i18n.changeLanguage(localStorage.getItem('language')||'en')
  }, [])
  return (
    <Provider store={store}>
      <Routes />
    </Provider>
  );
}

export default App;
